import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { SortArrowUpSVG } from '@common_components/svg/sortArrowUp.svg';

const SortArrowUpIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <SortArrowUpSVG/>
    </div>
  );
};

export { SortArrowUpIcon };
